"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Ellipsis;

var _react = _interopRequireDefault(require("react"));

function Ellipsis() {
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "pagination-ellipsis"
  }, "\u2026"));
}